export default __webpack_public_path__ + "static/media/0019.e408a309.WAV";